import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Poll from "@mui/icons-material/Poll";

import WrapperPaperTag from "../WrapperPaperTag";

const SurveyMenu = ({ question, options, onClick, onClose, isEditMode, stepTypeSelected }) => {
	return (
		<WrapperPaperTag onClick={onClick} onClose={onClose} isEditMode={isEditMode}>
			<Box
				sx={{
					mt: 2,
					display: "flex",
					flexDirection: "column",
					gap: 1,
					borderRadius: "4px",
					padding: "16px",
					width: "fit-content",
					maxWidth: "100%",
					margin: "8px"
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<Poll fontSize="small" />
					<Typography variant="body2" sx={{ fontWeight: "bold" }}>
						{stepTypeSelected === "solution" ? "Solution" : "Sondage"}
					</Typography>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "medium" }}>
					{question}
				</Typography>

				{options.map((option, index) => (
					<Typography key={index} variant="body2" sx={{ color: "#666" }}>
						{option.label}
					</Typography>
				))}
			</Box>
		</WrapperPaperTag>
	);
};

export default SurveyMenu;
